module.exports = __webpack_public_path__ + "img/gis2.263c6955.png";